<div class="apply-wrapper">

  <!-- Header -->
  <div class="apply-header">
    <div class="header-left">
      <button class="back-btn" (click)="goBack()">
        <i class="pi pi-angle-left"></i>
      </button>
      <div class="company-logo">
        <img [src]="companyLogo" [alt]="companyName" *ngIf="companyLogo; else logoFallback" />
        <ng-template #logoFallback>
          <span class="logo-initials">{{ companyInitials }}</span>
        </ng-template>
      </div>
      <h1 class="job-title">{{ jobTitle }}</h1>
    </div>
    <button class="view-company-btn" (click)="viewCompany()">
      {{ 'jobApply.viewCompany' | translate }}
    </button>
  </div>

  <!-- Error Alert -->
  <div class="alert alert-danger" *ngIf="errorMessage" role="alert">
    <button type="button" class="btn-close" (click)="errorMessage = ''"></button>
    <strong>{{ 'jobApply.error' | translate }}:</strong> {{ errorMessage }}
  </div>

  <!-- Steps -->
  <div class="apply-steps-container">
    <div class="apply-steps">
      <div class="line"></div>
      <div class="spacer"></div>
      <ng-container *ngFor="let step of steps; let i = index">
        <div class="step-item" [class.active]="activeIndex === i" [class.completed]="activeIndex > i">
          <div class="step-circle">
            <i class="pi pi-check" *ngIf="activeIndex > i; else stepNumber"></i>
            <ng-template #stepNumber>{{ i + 1 }}</ng-template>
          </div>
          <span class="step-label">{{ step.label }}</span>
        </div>
        <div class="spacer"></div>
      </ng-container>
    </div>
  </div>

  <!-- Step Content -->
  <div class="apply-content">

    <!-- Step 0/1: Questions -->
    <app-job-questions
      *ngIf="steps[activeIndex]?.id === 'questions'"
      [questions]="questions"
      (next)="onAnswersSubmitted($event)"
      (cancel)="cancel()"
    />

    <!-- Step 1/2: CV -->
    <ng-container *ngIf="steps[activeIndex]?.id === 'cv'">

      <!-- No CV Hint - تظهر بس لو اختار Upload -->
      <div class="no-cv-hint" *ngIf="selectedCVType === 'upload'">
        <div class="hint-icon">
          <i class="pi pi-file-edit"></i>
        </div>
        <div class="hint-body">
          <p class="hint-title">{{ 'jobApply.dontHaveCVYet' | translate }}</p>
          <p class="hint-desc">{{ 'jobApply.createProfessionalCV' | translate }}</p>
        </div>
        <a routerLink="/generatResume" class="hint-cta">
          <i class="pi pi-sparkles"></i>
          {{ 'Build My CV' | translate }}
        </a>
      </div>

      <app-upload-cv
        (next)="onCVSubmitted($event)"
        (cancel)="previous()"
        (selectionChange)="onCVTypeChanged($event)"
      />

    </ng-container>

  </div>

  <!-- Submitting Overlay -->
  <div class="submitting-overlay" *ngIf="isSubmitting">
    <div class="spinner-border text-danger" role="status"></div>
    <p>{{ 'jobApply.submittingApplication' | translate }}</p>
  </div>

  <!-- Success Popup -->
  <div class="success-overlay" *ngIf="showSuccessPopup" (click)="closeSuccessAndNavigate()">
    <div class="success-popup" (click)="$event.stopPropagation()">
      <div class="success-icon-wrapper">
        <div class="success-ring"></div>
        <div class="success-icon">
          <i class="bi bi-check-lg"></i>
        </div>
      </div>
      <h3>{{ 'jobApply.applicationSubmitted' | translate }}</h3>
      <p>{{ 'jobApply.applicationSentSuccessfully' | translate }}</p>
      <button class="success-btn gradient-button" (click)="closeSuccessAndNavigate()">
        {{ 'jobApply.backToJobs' | translate }}
      </button>
    </div>
  </div>

</div>